document.addEventListener('DOMContentLoaded', function () {
  // set the height of the drawer according to the presence of announcement bar 
  var desktop_megamenu_padding = document.getElementById('megamenu-drawer');
  var mobile_megamenu_padding = document.getElementById('NavDrawer');
  var stickyHeaderWrap = document.querySelector('.header-sticky-wrapper'); 
  if(stickyHeaderWrap){
    let get_height = stickyHeaderWrap.offsetHeight;
    if (desktop_megamenu_padding) {
      manage_megamenu_height(desktop_megamenu_padding, get_height);
    }
    if (mobile_megamenu_padding) {
      manage_megamenu_height(mobile_megamenu_padding, get_height);
    }
  }
  function manage_megamenu_height(element,set_height){
    element.style.top = set_height+"px";
  }

  const megamenuLinks = document.querySelectorAll('[data-megamenu="true"]');
  const drawer = document.getElementById('megamenu-drawer');
  const submenuDrawer = document.getElementById('submenu-drawer');
  const removeindex = document.querySelectorAll('.submenu-item  .menu-item');
  var ismegamenuopen = false;

  // Remove active class from all submenus
  function removeActiveSubmenus(selector) {
    const submenus = document.querySelectorAll(selector);
    submenus.forEach((submenu) => submenu.classList.remove('active'));
  }

  // Add click listener to megamenu links
  megamenuLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      if(!ismegamenuopen){

        // Open megamenu drawer
        submenuDrawer.classList.remove('open');
        drawer.classList.add('open');
        drawer.setAttribute('tabindex', '-1');
        removeindex.forEach((event)=>{
          event.removeAttribute('tabindex');
        });        
        ismegamenuopen = true;

        if (drawer.classList.contains('open')) {
          const dialog = document.querySelector('#megamenu-drawer');
          const firstFocusableElement = dialog;
          let lastFocusableElement;

          const getLastButton = () => {
            const buttons = document.querySelectorAll('.submenu-item > button.menu-item');
            return buttons[buttons.length - 1];
          };

          const getLastSubmenuLink = () => {
            const submenuLinks = document.querySelectorAll('.submenu.active li > a.menu-item');
            if (submenuLinks.length > 0) {
              return submenuLinks[submenuLinks.length - 1];
            }
            return null;
          };

          // Step 1: Set initial lastFocusableElement to last button
          lastFocusableElement = getLastButton();

          // Step 2: Add click listener to the last button
          const lastButton = getLastButton();
          if (lastButton) {
            lastButton.addEventListener('click', () => {
              // Delay to wait for submenu to render
                const newLast = getLastSubmenuLink();
                if (newLast) {
                  lastFocusableElement = newLast;
                }
            });
          }

          dialog.addEventListener('keydown', function (e) {
            if (e.key === 'Tab' && e.shiftKey && e.target === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }

            // Tab from last should cycle back to first
            else if (e.key === 'Tab' && !e.shiftKey && e.target === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          });
        }



      }else{
        submenuDrawer.classList.remove('open');
        drawer.classList.remove('open');
        drawer.removeAttribute('tabindex');
        removeActiveSubmenus('li.submenu-item > .menu-item');
        removeActiveSubmenus('ul.submenu');
        removeActiveSubmenus('.submenu-drawer-image');
        ismegamenuopen = false;
      }
    });
  });

  // Add click listener to submenu items
  const submenuItems = document.querySelectorAll('li.submenu-item > .menu-item');
  let activeMenuItem = null; // Track the currently active menu item
  
  submenuItems.forEach((menuItem) => {
    menuItem.addEventListener('click', (event) => {
        const submenu = menuItem.nextElementSibling?.classList.contains('submenu') 
          ? menuItem.nextElementSibling : null;
           // Check if the next sibling is a submenu
        const drawerImage = submenu 
          ? submenu.nextElementSibling?.classList.contains('submenu-drawer-image') 
            ? submenu.nextElementSibling 
            : null 
          : menuItem.nextElementSibling?.classList.contains('submenu-drawer-image') 
            ? menuItem.nextElementSibling 
            : null; // Check if drawer image exists
  
        // remove the active submenu-item 
        if (activeMenuItem && activeMenuItem !== menuItem) {
          const activeSubmenu = activeMenuItem.nextElementSibling?.classList.contains('submenu') 
            ? activeMenuItem.nextElementSibling 
            : null;
          const activeDrawerImage = activeSubmenu 
            ? activeSubmenu.nextElementSibling?.classList.contains('submenu-drawer-image') 
              ? activeSubmenu.nextElementSibling 
              : null 
            : activeMenuItem.nextElementSibling?.classList.contains('submenu-drawer-image') 
              ? activeMenuItem.nextElementSibling 
              : null;
  
          if (activeSubmenu) activeSubmenu.classList.remove('active');
          if (activeDrawerImage) activeDrawerImage.classList.remove('active');
          activeMenuItem.classList.remove('active');
        }
  
        // Toggle the current submenu and drawer image
        const isActive = menuItem.classList.contains('active');
        menuItem.classList.toggle('active', !isActive);
        if (submenu) submenu.classList.toggle('active', !isActive);
        if (drawerImage) drawerImage.classList.toggle('active', !isActive);
  
        activeMenuItem = !isActive ? menuItem : null; // Update the active menu item
      
    });
  });

  // Add click listener to submenu links for activating sub-submenus
  const submenuLinks = document.querySelectorAll('ul.submenu li > .menu-item');
  submenuLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      console.log(event, " my");
      // event.preventDefault();
      submenuLinks.forEach((item) => {
        item.classList.remove('active');
      });
      link.classList.add('active');
      // Find the corresponding sub-submenu
      const parentItem = link.closest('li');
      const subSubmenu = parentItem.querySelector('ul.sub-submenu');
      if (subSubmenu) {
        // Remove active class from all other sub-submenus
        removeActiveSubmenus('ul.sub-submenu');
        // Add active class to the clicked sub-submenu
        subSubmenu.classList.add('active');
      }
    });
  });

  // Close drawers when clicking outside
  document.addEventListener('click', (event) => {
    if (
      !drawer.contains(event.target) &&
      !submenuDrawer.contains(event.target) &&
      !event.target.matches('[data-megamenu="true"]') &&
      !event.target.closest('li.submenu-item') && 
      !event.target.classList.contains('submenu-arrow')
    ) {
      ismegamenuopen = false;
      drawer.classList.remove('open');
      submenuDrawer.classList.remove('open');
      removeActiveSubmenus('ul.submenu'); // Remove active class from submenus
      removeActiveSubmenus('ul.sub-submenu'); // Remove active class from sub-submenus
      document.querySelectorAll('.submenu-drawer-image').forEach(function (item) {
        item.classList.remove('active');
      });
    }
  });
});